import { Down24, Download16, Remove24 } from "@bphxd/ds-core-react/lib/icons";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import "./QuickSearch.scss";
import SvgSearch24 from "@bphxd/ds-core-react/lib/icons/interface/Search24";
import { Button } from "@bphxd/ds-core-react/lib/components/button/Button";
import { useEffect, useState,useRef } from "react";
import { useWindowSize } from "@bphxd/ds-core-react";
//import { fetchRegionSearchVals } from "../../api/DRN/drnsearch";
import { DrnViewModel } from "../../model/DrnViewModel";
import { downloadSelectedDrn } from "../../api/DRN/drndownload";
import { useMsal } from "@azure/msal-react";
import { LoginCaller } from "../../pages/Login";



function MultiSelectDropdown({ label, items, selected, onToggle, disabled = false }: {
  label: string; items: string[]; selected: string[];
  onToggle: (item: string) => void; disabled?: boolean;
})

{
  const [open, setOpen] = useState(false); // to control dropdown open/close state
  const [search, setSearch] = useState("");  // to seach box inside dropdown

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
  if (!open) setSearch("");
    }, [open]); 


    
  return (
    <>
    <div ref={ref} className="w-100" style={{ position: "relative" }}>
      <button type="button" disabled={disabled}
        className="w-100 rounded-0 ft-size text-secondary"
        style={{ background: "#fff", border: "1px solid #ced4da", textAlign: "left",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0.25rem 0.5rem", opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "pointer", minHeight: 33 }}
        onClick={() => !disabled && setOpen(o => !o)}>

       <span>
    {selected.length===0 ? label : `${label}(${selected.length})`}
    </span>
      <Down24 color="#007f00 !important" className="btn-icon-suffix" />
      </button>

      {open && (
    <div className="dropdown-menu show w-100 ft-size"
    style={{ maxHeight: 280, overflowY: "auto", position: "absolute", zIndex: 1050 }}>
    
    {/* SEARCH INPUT */}
    <div style={{ padding: "6px 8px", borderBottom: "1px solid #eee" }}>
      <input
        type="text"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{ width: "100%", border: "1px solid #ced4da", borderRadius: 4,
          padding: "3px 8px", fontSize: 12, outline: "none" }}
      />
    </div>

      {/* SELECTED PILLS */}
    {selected.length > 0 && (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 3, padding: "6px 8px",
        borderBottom: "1px solid #eee" }}>
        {selected.map(s => (
          <span key={s} style={{ background: "#f0f0f0", color: "#333", borderRadius: 999,
            padding: "1px 7px", fontSize: 11, display: "inline-flex", alignItems: "center", gap: 3 }}>
            {s}
            <span style={{ cursor: "pointer", fontWeight: 700 }}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => { e.stopPropagation(); onToggle(s); }}>×</span>
          </span>
        ))}
      </div>
    )}

    {/* FILTERED ITEMS */}
    {items
      .filter(item => item.toLowerCase().includes(search.toLowerCase()))
      .map(item => (
        <button type="button" key={item}
          className="dropdown-item ft-size d-flex align-items-center justify-content-between"
          style={{ fontWeight: selected.includes(item) ? 600 : 400 }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => { e.stopPropagation(); onToggle(item); }}>
          <span>{item}</span>
          {selected.includes(item) && <span style={{ color: "#000000", fontSize: 14 }}>✓</span>}
        </button>
    ))}
  </div>
)}
 
 


    </div>
   
      </>
  );
}

export default function QuickSearch({
  onSearch,
  setSearchValsState,
  setTotalRecordsCount,
  setNoDatafound,
  regionData,
  setSelectedField,
  setEnableAgGrid,
  telemetryEnabled,
}: {
  onSearch: (
    searchField: string,
    searchVal: string,
    region: string[],
    country: string[],
    port: string[] ,
    offSet: number,
    shouldCallDropdownApi?: boolean
  ) => void;
  setSearchValsState: React.Dispatch<
    React.SetStateAction<{
      sField: string;
      sText: string;
      sRegion: string[];
      sCountry: string[];
      sPort: string[];
    }>
  >;
  setTotalRecordsCount: React.Dispatch<React.SetStateAction<number>>;
  setNoDatafound: React.Dispatch<React.SetStateAction<string>>;
  regionData: any;
  setSelectedField: React.Dispatch<React.SetStateAction<string>>;
  setEnableAgGrid: React.Dispatch<React.SetStateAction<boolean>>;
  telemetryEnabled:any;
}) {
  const [searchField, setsearchField] = useState<string>("Select Category");
  const [searchText, setSearchText] = useState<string>("");
  //const [regionData, setRegionData] = useState<any>([]);
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const [selectedPorts, setSelectedPorts] = useState<string[]>([]);
  const [countryItem, setCountryitem] = useState<any>([]);
  const [portItem, setPortItem] = useState<string[]>([]);
  const [enableCtry, setEnableCtry] = useState<boolean>(false);
  const [enablePort, setEnablePort] = useState<boolean>(false);

  const { instance, accounts } = useMsal();
  const accessTokenRequest = {
    account: accounts[0],
    scopes: ["User.Read"],
  };
  
    const account = accounts[0];
  
    const email =
      account?.username ||
      account?.idTokenClaims?.preferred_username;
  
    console.log("User Email in queisc search:", email);
    sessionStorage.setItem('vendorUsername', email || '');
  // const token = accessTokenRequest.account.idToken;
  const token = sessionStorage.getItem("jwt");
  const role = sessionStorage.getItem('role');
  const { width } = useWindowSize();
  const ddList = ["Order Number", "ERP Order Number", "UOA (GR) Number", "Invoice Number", "Customer Sold-To-ID", "Customer Account Name", "Region", "Country of Supply", "Port", "Vessel Name", "Vessel IMO Number"];
  useEffect(() => {
    if (role === LoginCaller.VENDOR) {
      setsearchField("Order Number");
    }
  }, [role]);

  useEffect(() => {
    console.log("searchField changed", searchField); 
    resetAllRegionFields();
    setSearchText("");
    setNoDatafound("");
    setSelectedField("");
    setEnableAgGrid(false);
    setTotalRecordsCount(0);
  }, [searchField]);

  
  const regx = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';.,_/{}()@|\\":<>\?]/);
  const validateAndSearch = () => {
    if (
      searchField !== "Region" &&
      searchField !== "Customer Account Name" &&
      searchField !== "Customer Sold-To-ID" &&
      searchField !== "Country of Supply" &&
      searchField !== "Port" &&
      searchField !== "Vessel Name" &&
      searchField !== "Vessel IMO Number"
    ) {
      if (regx.test(searchText)) {
        setNoDatafound(
          "Please only use numbers and letters in the search field as special characters are not supported."
        );
        setSelectedField("");
        setEnableAgGrid(false);
      } 
    else 
        {
  onSearch(searchField, searchText, selectedRegions, selectedCountries, selectedPorts, 0,true);
  setSearchValsState({
  sField: searchField,
  sText: searchText,
  sRegion: selectedRegions,
  sCountry: selectedCountries,
  sPort: selectedPorts,
  });

      }
  } 
    
  else 
    {
  onSearch(searchField, searchText, selectedRegions, selectedCountries, selectedPorts, 0, true);
  setSearchValsState({
  sField: searchField,
  sText: searchText,
  sRegion: selectedRegions,
  sCountry: selectedCountries,
  sPort: selectedPorts,
                   });
    }
    };

  const resetAllRegionFields = () => {
    setSelectedRegions([]);
    setSelectedCountries([]);
    setSelectedPorts([]);
    setEnableCtry(false);
    setEnablePort(false);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter") {
      if (
        searchField !== "Select Category" &&
        (searchText !== "" || selectedRegions.length > 0)
      ) 
      {
        event.preventDefault();
        event.stopPropagation();
        setTotalRecordsCount(0);
        validateAndSearch();
      }
    }
  };
  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.currentTarget.value);
    setNoDatafound("");
  };
  const handleRegionToggle = (name: string) => {
  setSelectedRegions(prev =>
    prev.includes(name) ? prev.filter(r => r !== name) : [...prev, name]
  );
};

useEffect(() => {
  setEnableCtry(selectedRegions.length > 0);
  if (!regionData?.length ) {
    setCountryitem([]);
    setSelectedCountries([]);
    return;
  }
  const allCountries = selectedRegions.flatMap(rName => {
    const found = regionData.find((r: any) => r.region_name === rName);
    return found ? found.country_name : [];
  }).sort((a: any, b: any) => a.name < b.name ? -1 : 1); 
  setCountryitem(allCountries);
  setSelectedCountries((prev) => prev.filter(c => allCountries.some((ac: any) => ac.name === c))); // REMOVE COUNTRIES NOT IN NEW LIST
}, [selectedRegions, regionData]);


  const handleCountryToggle = (name: string) => {
  setSelectedCountries(prev =>{
  const updatedCountries = prev.includes(name) ? prev.filter(c => c !== name) : [...prev, name];
  return updatedCountries;
  }); 
};


const handlePortToggle = (name: string) => {
  setSelectedPorts(prev =>
    prev.includes(name) ? prev.filter(p => p !== name) : [...prev, name]
  );
};


useEffect(() => {
  setEnablePort(selectedCountries.length > 0);
  if (!countryItem?.length ) {
      setPortItem([]);
      setSelectedPorts([]); 
  return;
  }
  const allPorts = selectedCountries.flatMap(cName => {
    const found = countryItem.find((c: any) => c.name === cName);
    return found ? found.port_name : [];
  }).sort((a: string, b: string) => a < b ? -1 : 1);
  
  setPortItem(allPorts);
  setSelectedPorts((prev) => prev.filter(p => allPorts.includes(p))); // REMOVE PORTS NOT IN NEW LIST
}, [selectedCountries,countryItem]);

  
  return (
    <>
      <div className="row" style={{ alignItems: "flex-end" }}>
        {role !== LoginCaller.VENDOR && (
          <div className="col-sm-3 col-lg-2 col-12">
            <UncontrolledDropdown size="sm" className="mb-4 ft-size">
              <DropdownToggle
                className="w-100 sch-drpdwn-toggle border-0 rounded-0 ft-size"
                color="#fff"
                caret
                id="quick-search-drop"
              >
                {searchField}
                <Down24 color="#007f00 !important" className="btn-icon-suffix" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-sm w-100 ft-size">
                {ddList.map((item, index) => (
                  <DropdownItem tabIndex={index}
                    onClick={() => {
                      setsearchField(item);
                    }}
                  >
                    {item}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )}

        {searchField !== "Region" && (
          <div className="col-sm-7 col-lg-5">
            <InputGroup
              className="input-group-merge mb-4 search-input"
              size="sm"
            >
              <Input
                className="form-control-prepended form-control-appended ft-size"
                placeholder={
                  role === LoginCaller.VENDOR
                    ? "Search with Orca Order number or New Marine Order number"
                    : searchField === "Select Category"
                    ? "Search"
                    : searchField === "Order Number" && width > 576
                    ? "Search with Orca Order number or New Marine Order number"
                    : `Search with ${searchField}`
                }
                type="text"
                onChange={onSearchTextChange}
                onKeyDown={onKeyDown}
                value={searchText}
              />
              <div className="input-group-prepend">
                <InputGroupText>
                  <SvgSearch24 color="#007f00" />
                </InputGroupText>
              </div>
              <div className="input-group-append">
                <InputGroupText onClick={() => setSearchText("")}>
                  {searchText !== "" && (
                    <Remove24 style={{ cursor: "pointer" }} />
                  )}
                </InputGroupText>
              </div>
            </InputGroup>
          </div>
        )}
        {searchField === "Region" && (
          <>
           <div className="col-sm-3 col-lg-2 col-12 mb-4">
  <MultiSelectDropdown
    label="Select Region"
    items={regionData.map((r: any) => r.region_name)}
    selected={selectedRegions}
    onToggle={(name) => {
      handleRegionToggle(name);
      setEnableCtry(true);
    }}
  />
</div>


  <div className="col-sm-3 col-lg-2 col-12 mb-4">
  <MultiSelectDropdown
    label="Select Country"
    items={countryItem.map((c: any) => c.name)}
    selected={selectedCountries}
    onToggle={handleCountryToggle}
    disabled={!enableCtry}
  />
</div>
           <div className="col-sm-3 col-lg-2 col-12 mb-4">
  <MultiSelectDropdown
    label="Select Port"
    items={portItem}
    selected={selectedPorts}
    onToggle={handlePortToggle}
    disabled={!enablePort}
  />
</div>
</>
)}
        <div className="col-sm-2">
          <Button
            rounded="pill"
            theme="brand"
            level="primary"
            size="sm"
            className="ft-size qik-srch-btn"
            style={{
                  width: "78px",
                  position: "relative",
                  top: "-15px"  
                  }}
            disabled={
              searchField !== "Select Category" &&
              (searchText !== "" || selectedRegions.length > 0)
                ? false
                : true
            }
            onClick={() => {
              validateAndSearch();
              setTotalRecordsCount(0);
            }}
          >
            Search
          </Button>
        </div>
        {/* <div
          className={searchField === "Region" ? "col-sm-1" : "col-sm-2"}
        ></div> */}
      </div>
    </>
  );
}
